import React from 'react';
import classNames from 'classnames';

const Card = ({ children, stripe }) => {
  const className = classNames('c-card c-card--all-sides-spacing', {
    'c-card--color-stripe': stripe,
  });
  return <div className={className}>{children}</div>;
};

export default Card;
